var items = {
  "block.minecraft.air": "aire",
  "block.minecraft.stone": "roca",
  "block.minecraft.granite": "granit",
  "block.minecraft.polished_granite": "granit polit",
  "block.minecraft.diorite": "diorita",
  "block.minecraft.polished_diorite": "diorita polida",
  "block.minecraft.andesite": "andesita",
  "block.minecraft.polished_andesite": "andesita polida",
  "block.minecraft.grass_block": "bloc d'herba",
  "block.minecraft.dirt": "terra",
  "block.minecraft.coarse_dirt": "terra estèril",
  "block.minecraft.podzol": "pinassa",
  "block.minecraft.crimson_nylium": "miceli carmesí",
  "block.minecraft.warped_nylium": "miceli estrambòtic",
  "block.minecraft.cobblestone": "empedrat",
  "block.minecraft.oak_planks": "taulons de fusta de pomer",
  "block.minecraft.spruce_planks": "taulons de fusta d'avet",
  "block.minecraft.birch_planks": "taulons de fusta de bedoll",
  "block.minecraft.jungle_planks": "taulons de fusta d'arbre de jungla",
  "block.minecraft.acacia_planks": "taulons de fusta d'acàcia",
  "block.minecraft.dark_oak_planks": "taulons de fusta de roure",
  "block.minecraft.crimson_planks": "taulons de fusta carmesí",
  "block.minecraft.warped_planks": "taulons de fusta estrambòtica",
  "block.minecraft.oak_sapling": "esqueix de pomer",
  "block.minecraft.spruce_sapling": "esqueix d'avet",
  "block.minecraft.birch_sapling": "esqueix de bedoll",
  "block.minecraft.jungle_sapling": "esqueix d'arbre de jungla",
  "block.minecraft.acacia_sapling": "esqueix d'acàcia",
  "block.minecraft.dark_oak_sapling": "esqueix de roure",
  "block.minecraft.bedrock": "roca base",
  "block.minecraft.sand": "arena",
  "block.minecraft.red_sand": "arena roja",
  "block.minecraft.gravel": "grava",
  "block.minecraft.gold_ore": "mena d'or",
  "block.minecraft.iron_ore": "mena de ferro",
  "block.minecraft.coal_ore": "mena de carbó",
  "block.minecraft.nether_gold_ore": "mena d'or del nether",
  "block.minecraft.oak_log": "tronc de pomer",
  "block.minecraft.spruce_log": "tronc d'avet",
  "block.minecraft.birch_log": "tronc de bedoll",
  "block.minecraft.jungle_log": "tronc d'arbre de jungla",
  "block.minecraft.acacia_log": "tronc d'acàcia",
  "block.minecraft.dark_oak_log": "tronc de roure",
  "block.minecraft.crimson_stem": "tija carmesina",
  "block.minecraft.warped_stem": "tija de fong estrambòtic",
  "block.minecraft.stripped_oak_log": "tronc de pomer escorçat",
  "block.minecraft.stripped_spruce_log": "tronc d'avet escorçat",
  "block.minecraft.stripped_birch_log": "tronc de bedoll escorçat",
  "block.minecraft.stripped_jungle_log": "tronc d'arbre de jungla escorçat",
  "block.minecraft.stripped_acacia_log": "tronc d'acàcia escorçat",
  "block.minecraft.stripped_dark_oak_log": "tronc de roure escorçat",
  "block.minecraft.stripped_crimson_stem": "tija carmesí escorçada",
  "block.minecraft.stripped_warped_stem": "tija de fong estrambòtic escorçada",
  "block.minecraft.stripped_oak_wood": "fusta de pomer escorçada",
  "block.minecraft.stripped_spruce_wood": "fusta d'avet escorçada",
  "block.minecraft.stripped_birch_wood": "fusta de bedoll escorçada",
  "block.minecraft.stripped_jungle_wood": "fusta d’arbre de jungla escorçada",
  "block.minecraft.stripped_acacia_wood": "fusta d’acàcia escorçada",
  "block.minecraft.stripped_dark_oak_wood": "fusta de roure escorçada",
  "block.minecraft.stripped_crimson_hyphae": "hifa carmesí escorçada",
  "block.minecraft.stripped_warped_hyphae": "hifa estrambòtica escorçada",
  "block.minecraft.oak_wood": "tronc de pomer",
  "block.minecraft.spruce_wood": "tronc d'avet",
  "block.minecraft.birch_wood": "tronc de bedoll",
  "block.minecraft.jungle_wood": "tronc d'arbre de jungla",
  "block.minecraft.acacia_wood": "tronc d'acàcia",
  "block.minecraft.dark_oak_wood": "tronc de roure",
  "block.minecraft.crimson_hyphae": "hifa carmesí",
  "block.minecraft.warped_hyphae": "hifa estrambòtica",
  "block.minecraft.oak_leaves": "fulles de pomer",
  "block.minecraft.spruce_leaves": "fulles d'avet",
  "block.minecraft.birch_leaves": "fulles de bedoll",
  "block.minecraft.jungle_leaves": "fulles d'arbre de jungla",
  "block.minecraft.acacia_leaves": "fulles d'acàcia",
  "block.minecraft.dark_oak_leaves": "fulles de roure",
  "block.minecraft.sponge": "esponja",
  "block.minecraft.wet_sponge": "esponja humida",
  "block.minecraft.glass": "vidre",
  "block.minecraft.lapis_ore": "mena de lapislàtzuli",
  "block.minecraft.lapis_block": "bloc de lapislàtzuli",
  "block.minecraft.dispenser": "dispensador",
  "block.minecraft.sandstone": "roca arenosa",
  "block.minecraft.chiseled_sandstone": "roca arenosa cisellada",
  "block.minecraft.cut_sandstone": "roca arenosa tallada",
  "block.minecraft.note_block": "bloc musical",
  "block.minecraft.powered_rail": "via d'accelaració",
  "block.minecraft.detector_rail": "via detectora",
  "block.minecraft.sticky_piston": "pistó apegalós",
  "block.minecraft.cobweb": "teranyina",
  "block.minecraft.grass": "herba",
  "block.minecraft.fern": "falaguera",
  "block.minecraft.dead_bush": "arbust mort",
  "block.minecraft.seagrass": "herba marina",
  "block.minecraft.sea_pickle": "cogombre de mar",
  "block.minecraft.piston": "pistó",
  "block.minecraft.white_wool": "llana blanca",
  "block.minecraft.orange_wool": "llana taronja",
  "block.minecraft.magenta_wool": "llana magenta",
  "block.minecraft.light_blue_wool": "llana blava clara",
  "block.minecraft.yellow_wool": "llana groga",
  "block.minecraft.lime_wool": "llana verd llima",
  "block.minecraft.pink_wool": "llana rosa",
  "block.minecraft.gray_wool": "llana grisa",
  "block.minecraft.light_gray_wool": "llana grisa clara",
  "block.minecraft.cyan_wool": "llana cian",
  "block.minecraft.purple_wool": "llana morada",
  "block.minecraft.blue_wool": "llana blava",
  "block.minecraft.brown_wool": "llana marró",
  "block.minecraft.green_wool": "llana verda",
  "block.minecraft.red_wool": "llana roja",
  "block.minecraft.black_wool": "llana negra",
  "block.minecraft.dandelion": "dent de lleó",
  "block.minecraft.poppy": "rosella",
  "block.minecraft.blue_orchid": "orquídia blava",
  "block.minecraft.allium": "allium",
  "block.minecraft.azure_bluet": "houstonia caerulea",
  "block.minecraft.red_tulip": "tulipa roja",
  "block.minecraft.orange_tulip": "tulipa taronja",
  "block.minecraft.white_tulip": "tulipa blanca",
  "block.minecraft.pink_tulip": "tulipa rosa",
  "block.minecraft.oxeye_daisy": "margarida",
  "block.minecraft.cornflower": "blauet",
  "block.minecraft.lily_of_the_valley": "lliri de la mare de déu",
  "block.minecraft.wither_rose": "rosa mústia",
  "block.minecraft.brown_mushroom": "xampinyó marró",
  "block.minecraft.red_mushroom": "xampinyó roig",
  "block.minecraft.crimson_fungus": "fong carmesí",
  "block.minecraft.warped_fungus": "fong estrambòtic",
  "block.minecraft.crimson_roots": "arrels carmesines",
  "block.minecraft.warped_roots": "arrels estrambòtiques",
  "block.minecraft.nether_sprouts": "brots del nether",
  "block.minecraft.weeping_vines": "lianes carmesines",
  "block.minecraft.twisting_vines": "lianes estrambòtiques",
  "block.minecraft.sugar_cane": "canya de sucre",
  "block.minecraft.kelp": "alga",
  "block.minecraft.bamboo": "bambú",
  "block.minecraft.gold_block": "bloc d'or",
  "block.minecraft.iron_block": "bloc de ferro",
  "block.minecraft.oak_slab": "llosa de fusta de pomer",
  "block.minecraft.spruce_slab": "llosa de fusta d'avet",
  "block.minecraft.birch_slab": "llosa de fusta de bedoll",
  "block.minecraft.jungle_slab": "llosa de fusta d'arbre de jungla",
  "block.minecraft.acacia_slab": "llosa de fusta d'acàcia",
  "block.minecraft.dark_oak_slab": "llosa de fusta de roure",
  "block.minecraft.crimson_slab": "llosa carmesí",
  "block.minecraft.warped_slab": "llosa estrambòtica",
  "block.minecraft.stone_slab": "llosa de roca",
  "block.minecraft.smooth_stone_slab": "llosa de roca llisa",
  "block.minecraft.sandstone_slab": "llosa de roca arenosa",
  "block.minecraft.cut_sandstone_slab": "llosa de roca arenosa tallada",
  "block.minecraft.petrified_oak_slab": "llosa petrificada de fusta de pomer",
  "block.minecraft.cobblestone_slab": "llosa d'empedrat",
  "block.minecraft.brick_slab": "llosa de rajoles",
  "block.minecraft.stone_brick_slab": "llosa de rajoles de roca",
  "block.minecraft.nether_brick_slab": "llosa de rajoles del nether",
  "block.minecraft.quartz_slab": "llosa de quars",
  "block.minecraft.red_sandstone_slab": "llosa de roca arenosa roja",
  "block.minecraft.cut_red_sandstone_slab": "llosa de roca arenosa roja tallada",
  "block.minecraft.purpur_slab": "llosa de purpur",
  "block.minecraft.prismarine_slab": "llosa de prismarina",
  "block.minecraft.prismarine_brick_slab": "llosa de rajoles de prismarina",
  "block.minecraft.dark_prismarine_slab": "llosa de prismarina obscura",
  "block.minecraft.smooth_quartz": "bloc de quars llis",
  "block.minecraft.smooth_red_sandstone": "roca arenosa roja llisa",
  "block.minecraft.smooth_sandstone": "roca arenosa llisa",
  "block.minecraft.smooth_stone": "roca llisa",
  "block.minecraft.bricks": "rajola",
  "block.minecraft.tnt": "explosius",
  "block.minecraft.bookshelf": "llibreria",
  "block.minecraft.mossy_cobblestone": "empedrat amb molsa",
  "block.minecraft.obsidian": "obsidiana",
  "block.minecraft.torch": "torxa",
  "block.minecraft.end_rod": "vara de la fi",
  "block.minecraft.chorus_plant": "coral",
  "block.minecraft.chorus_flower": "flor de coral",
  "block.minecraft.purpur_block": "bloc de purpur",
  "block.minecraft.purpur_pillar": "pilar de purpur",
  "block.minecraft.purpur_stairs": "escales de purpur",
  "block.minecraft.spawner": "generador d'entitats",
  "block.minecraft.oak_stairs": "escales de fusta de pomer",
  "block.minecraft.chest": "cofre",
  "block.minecraft.diamond_ore": "mena de diamant",
  "block.minecraft.diamond_block": "bloc de diamant",
  "block.minecraft.crafting_table": "taula de manufactures",
  "block.minecraft.farmland": "terra arada",
  "block.minecraft.furnace": "forn",
  "block.minecraft.ladder": "escala",
  "block.minecraft.rail": "via",
  "block.minecraft.cobblestone_stairs": "escales d'empedrat",
  "block.minecraft.lever": "palanca",
  "block.minecraft.stone_pressure_plate": "placa de pressió de pedra",
  "block.minecraft.oak_pressure_plate": "placa de pressió de fusta de pomer",
  "block.minecraft.spruce_pressure_plate": "placa de pressió de fusta d'avet",
  "block.minecraft.birch_pressure_plate": "placa de pressió de fusta de bedoll",
  "block.minecraft.jungle_pressure_plate": "placa de pressió de fusta d'arbre de jungla",
  "block.minecraft.acacia_pressure_plate": "placa de pressió de fusta d'acàcia",
  "block.minecraft.dark_oak_pressure_plate": "placa de pressió de fusta de roure",
  "block.minecraft.crimson_pressure_plate": "placa de pressió carmesí",
  "block.minecraft.warped_pressure_plate": "placa de pressió estrambòtica",
  "block.minecraft.polished_blackstone_pressure_plate": "placa de pressió de roca negra polida",
  "block.minecraft.redstone_ore": "mena de redstone",
  "block.minecraft.redstone_torch": "torxa de redstone",
  "block.minecraft.snow": "neu",
  "block.minecraft.ice": "gel",
  "block.minecraft.snow_block": "bloc de neu",
  "block.minecraft.cactus": "cactus",
  "block.minecraft.clay": "argila",
  "block.minecraft.jukebox": "tocadiscs",
  "block.minecraft.oak_fence": "tanca de fusta de pomer",
  "block.minecraft.spruce_fence": "tanca de fusta d'avet",
  "block.minecraft.birch_fence": "tanca de fusta de bedoll",
  "block.minecraft.jungle_fence": "tanca de fusta d'arbre de jungla",
  "block.minecraft.acacia_fence": "tanca de fusta d'acàcia",
  "block.minecraft.dark_oak_fence": "tanca de fusta de roure",
  "block.minecraft.crimson_fence": "tanca carmesí",
  "block.minecraft.warped_fence": "tanca estrambòtica",
  "block.minecraft.pumpkin": "carabassa",
  "block.minecraft.carved_pumpkin": "carabassa tallada",
  "block.minecraft.netherrack": "roca del nether",
  "block.minecraft.soul_sand": "arena d'ànimes",
  "block.minecraft.soul_soil": "terra d'ànimes",
  "block.minecraft.basalt": "basalt",
  "block.minecraft.polished_basalt": "basalt polit",
  "block.minecraft.soul_torch": "torxa d'ànimes",
  "block.minecraft.glowstone": "roca brillant",
  "block.minecraft.jack_o_lantern": "carabassa de halloween",
  "block.minecraft.oak_trapdoor": "trapa de fusta de pomer",
  "block.minecraft.spruce_trapdoor": "trapa de fusta d'avet",
  "block.minecraft.birch_trapdoor": "trapa de fusta de bedoll",
  "block.minecraft.jungle_trapdoor": "trapa de fusta d'arbre de jungla",
  "block.minecraft.acacia_trapdoor": "trapa de fusta d'acàcia",
  "block.minecraft.dark_oak_trapdoor": "trapa de fusta de roure",
  "block.minecraft.crimson_trapdoor": "trapa carmesí",
  "block.minecraft.warped_trapdoor": "trapa estrambòtica",
  "block.minecraft.infested_stone": "roca infestada",
  "block.minecraft.infested_cobblestone": "empedrat infestat",
  "block.minecraft.infested_stone_bricks": "rajoles de roca infestades",
  "block.minecraft.infested_mossy_stone_bricks": "rajoles de roca amb molsa infestades",
  "block.minecraft.infested_cracked_stone_bricks": "rajoles de roca esquerdades infestades",
  "block.minecraft.infested_chiseled_stone_bricks": "rajoles de roca cisellades infestades",
  "block.minecraft.stone_bricks": "rajoles de roca",
  "block.minecraft.mossy_stone_bricks": "rajoles de roca amb molsa",
  "block.minecraft.cracked_stone_bricks": "rajoles de roca esquerdades",
  "block.minecraft.chiseled_stone_bricks": "rajoles de roca cisellades",
  "block.minecraft.brown_mushroom_block": "bloc de xampinyó marró",
  "block.minecraft.red_mushroom_block": "bloc de xampinyó roig",
  "block.minecraft.mushroom_stem": "tija de xampinyó",
  "block.minecraft.iron_bars": "reixa de ferro",
  "block.minecraft.chain": "cadena",
  "block.minecraft.glass_pane": "panell de vidre",
  "block.minecraft.melon": "meló d'alger",
  "block.minecraft.vine": "lianes",
  "block.minecraft.oak_fence_gate": "porta de tanca de fusta de pomer",
  "block.minecraft.spruce_fence_gate": "porta de tanca de fusta d'avet",
  "block.minecraft.birch_fence_gate": "porta de tanca de fusta de bedoll",
  "block.minecraft.jungle_fence_gate": "porta de tanca de fusta d'arbre de jungla",
  "block.minecraft.acacia_fence_gate": "porta de tanca de fusta d'acàcia",
  "block.minecraft.dark_oak_fence_gate": "porta de tanca de fusta de roure",
  "block.minecraft.crimson_fence_gate": "porta de tanca carmesí",
  "block.minecraft.warped_fence_gate": "porta de tanca estrambòtica",
  "block.minecraft.brick_stairs": "escales de rajola",
  "block.minecraft.stone_brick_stairs": "escales de rajola de roca",
  "block.minecraft.mycelium": "miceli",
  "block.minecraft.lily_pad": "nenúfar",
  "block.minecraft.nether_bricks": "rajoles del nether",
  "block.minecraft.cracked_nether_bricks": "rajoles del nether esquerdades",
  "block.minecraft.chiseled_nether_bricks": "rajoles del nether cisellades",
  "block.minecraft.nether_brick_fence": "tanca de rajola del nether",
  "block.minecraft.nether_brick_stairs": "escales de rajola del nether",
  "block.minecraft.enchanting_table": "taula d'encanteris",
  "block.minecraft.end_portal_frame": "marc del portal a la fi",
  "block.minecraft.end_stone": "roca de la fi",
  "block.minecraft.end_stone_bricks": "rajoles de roca de la fi",
  "block.minecraft.dragon_egg": "ou del drac de la fi",
  "block.minecraft.redstone_lamp": "làmpada de redstone",
  "block.minecraft.sandstone_stairs": "escales de roca arenosa",
  "block.minecraft.emerald_ore": "mena de maragda",
  "block.minecraft.ender_chest": "cofre de la fi",
  "block.minecraft.tripwire_hook": "ganxo",
  "block.minecraft.emerald_block": "bloc de maragda",
  "block.minecraft.spruce_stairs": "escales de fusta d'avet",
  "block.minecraft.birch_stairs": "escales de fusta de bedoll",
  "block.minecraft.jungle_stairs": "escales de fusta d'arbre de jungla",
  "block.minecraft.crimson_stairs": "escales carmesí",
  "block.minecraft.warped_stairs": "escales estrambòtiques",
  "block.minecraft.command_block": "bloc de comandaments",
  "block.minecraft.beacon": "far màgic",
  "block.minecraft.cobblestone_wall": "mur d'empedrat",
  "block.minecraft.mossy_cobblestone_wall": "mur d'empedrat amb molsa",
  "block.minecraft.brick_wall": "mur de rajoles",
  "block.minecraft.prismarine_wall": "mur de prismarina",
  "block.minecraft.red_sandstone_wall": "mur de roca arenosa roja",
  "block.minecraft.mossy_stone_brick_wall": "mur de rajoles de roca amb molsa",
  "block.minecraft.granite_wall": "mur de granit",
  "block.minecraft.stone_brick_wall": "mur de rajoles de roca",
  "block.minecraft.nether_brick_wall": "mur de rajoles del nether",
  "block.minecraft.andesite_wall": "mur d'andesita",
  "block.minecraft.red_nether_brick_wall": "mur de rajoles del nether roges",
  "block.minecraft.sandstone_wall": "mur de roca arenosa",
  "block.minecraft.end_stone_brick_wall": "mur de rajoles de roca de la fi",
  "block.minecraft.diorite_wall": "mur de diorita",
  "block.minecraft.blackstone_wall": "mur de roca negra",
  "block.minecraft.polished_blackstone_wall": "mur de roca negra polida",
  "block.minecraft.polished_blackstone_brick_wall": "mur de rajoles de roca negra polida",
  "block.minecraft.stone_button": "botó de pedra",
  "block.minecraft.oak_button": "botó de fusta de pomer",
  "block.minecraft.spruce_button": "botó de fusta d'avet",
  "block.minecraft.birch_button": "botó de fusta de bedoll",
  "block.minecraft.jungle_button": "botó de fusta d'arbre de jungla",
  "block.minecraft.acacia_button": "botó de fusta d'acàcia",
  "block.minecraft.dark_oak_button": "botó de fusta de roure",
  "block.minecraft.crimson_button": "botó de fusta carmesina",
  "block.minecraft.warped_button": "botó estrambòtic",
  "block.minecraft.polished_blackstone_button": "botó de roca negra polida",
  "block.minecraft.anvil": "enclusa",
  "block.minecraft.chipped_anvil": "enclusa esquerdada",
  "block.minecraft.damaged_anvil": "enclusa vella",
  "block.minecraft.trapped_chest": "cofre trampa",
  "block.minecraft.light_weighted_pressure_plate": "placa de pressió per a pes lleuger",
  "block.minecraft.heavy_weighted_pressure_plate": "placa de pressió per a pes elevat",
  "block.minecraft.daylight_detector": "sensor de llum solar",
  "block.minecraft.redstone_block": "bloc de redstone",
  "block.minecraft.nether_quartz_ore": "mena de quars",
  "block.minecraft.hopper": "tremuja",
  "block.minecraft.chiseled_quartz_block": "bloc de quars cisellat",
  "block.minecraft.quartz_block": "bloc de quars",
  "block.minecraft.quartz_bricks": "rajoles de quars",
  "block.minecraft.quartz_pillar": "pilar de quars",
  "block.minecraft.quartz_stairs": "escales de quars",
  "block.minecraft.activator_rail": "via activadora",
  "block.minecraft.dropper": "subministrador",
  "block.minecraft.white_terracotta": "terracota blanca",
  "block.minecraft.orange_terracotta": "terracota taronja",
  "block.minecraft.magenta_terracotta": "terracota magenta",
  "block.minecraft.light_blue_terracotta": "terracota blava clara",
  "block.minecraft.yellow_terracotta": "terracota groga",
  "block.minecraft.lime_terracotta": "terracota verda llima",
  "block.minecraft.pink_terracotta": "terracota rosa",
  "block.minecraft.gray_terracotta": "terracota grisa",
  "block.minecraft.light_gray_terracotta": "terracota grisa clara",
  "block.minecraft.cyan_terracotta": "terracota cian",
  "block.minecraft.purple_terracotta": "terracota morada",
  "block.minecraft.blue_terracotta": "terracota blava",
  "block.minecraft.brown_terracotta": "terracota marró",
  "block.minecraft.green_terracotta": "terracota verda",
  "block.minecraft.red_terracotta": "terracota roja",
  "block.minecraft.black_terracotta": "terracota negra",
  "block.minecraft.barrier": "barrera",
  "block.minecraft.iron_trapdoor": "trapa de ferro",
  "block.minecraft.hay_block": "bala de fenc",
  "block.minecraft.white_carpet": "estora blanca",
  "block.minecraft.orange_carpet": "estora taronja",
  "block.minecraft.magenta_carpet": "estora magenta",
  "block.minecraft.light_blue_carpet": "estora blava clara",
  "block.minecraft.yellow_carpet": "estora groga",
  "block.minecraft.lime_carpet": "estora verda llima",
  "block.minecraft.pink_carpet": "estora rosa",
  "block.minecraft.gray_carpet": "estora grisa",
  "block.minecraft.light_gray_carpet": "estora grisa clara",
  "block.minecraft.cyan_carpet": "estora cian",
  "block.minecraft.purple_carpet": "estora morada",
  "block.minecraft.blue_carpet": "estora blava",
  "block.minecraft.brown_carpet": "estora marró",
  "block.minecraft.green_carpet": "estora verda",
  "block.minecraft.red_carpet": "estora roja",
  "block.minecraft.black_carpet": "estora negra",
  "block.minecraft.terracotta": "terracota",
  "block.minecraft.coal_block": "bloc de carbó",
  "block.minecraft.packed_ice": "gel compacte",
  "block.minecraft.acacia_stairs": "escales de fusta d'acàcia",
  "block.minecraft.dark_oak_stairs": "escales de fusta de roure",
  "block.minecraft.slime_block": "bloc de llim",
  "block.minecraft.grass_path": "camí d'herba",
  "block.minecraft.sunflower": "gira-sol",
  "block.minecraft.lilac": "lilà",
  "block.minecraft.rose_bush": "roser",
  "block.minecraft.peony": "peònia",
  "block.minecraft.tall_grass": "herba alta",
  "block.minecraft.large_fern": "falaguera gran",
  "block.minecraft.white_stained_glass": "vidriera blanca",
  "block.minecraft.orange_stained_glass": "vidriera taronja",
  "block.minecraft.magenta_stained_glass": "vidriera magenta",
  "block.minecraft.light_blue_stained_glass": "vidriera blau clar",
  "block.minecraft.yellow_stained_glass": "vidriera groga",
  "block.minecraft.lime_stained_glass": "vidriera verd llima",
  "block.minecraft.pink_stained_glass": "vidriera rosa",
  "block.minecraft.gray_stained_glass": "vidriera grisa",
  "block.minecraft.light_gray_stained_glass": "vidriera grisa clara",
  "block.minecraft.cyan_stained_glass": "vidriera cian",
  "block.minecraft.purple_stained_glass": "vidriera morada",
  "block.minecraft.blue_stained_glass": "vidriera blava",
  "block.minecraft.brown_stained_glass": "vidriera marró",
  "block.minecraft.green_stained_glass": "vidriera verda",
  "block.minecraft.red_stained_glass": "vidriera roja",
  "block.minecraft.black_stained_glass": "vidriera negra",
  "block.minecraft.white_stained_glass_pane": "panell de vidriera blanc",
  "block.minecraft.orange_stained_glass_pane": "panell de vidriera taronja",
  "block.minecraft.magenta_stained_glass_pane": "panell de vidriera magenta",
  "block.minecraft.light_blue_stained_glass_pane": "panell de vidriera blau clar",
  "block.minecraft.yellow_stained_glass_pane": "panell de vidriera groc",
  "block.minecraft.lime_stained_glass_pane": "panell de vidriera verd llima",
  "block.minecraft.pink_stained_glass_pane": "panell de vidriera rosa",
  "block.minecraft.gray_stained_glass_pane": "panell de vidriera gris",
  "block.minecraft.light_gray_stained_glass_pane": "panell de vidriera gris clar",
  "block.minecraft.cyan_stained_glass_pane": "panell de vidriera cian",
  "block.minecraft.purple_stained_glass_pane": "panell de vidriera morat",
  "block.minecraft.blue_stained_glass_pane": "panell de vidriera blau",
  "block.minecraft.brown_stained_glass_pane": "panell de vidriera marró",
  "block.minecraft.green_stained_glass_pane": "panell de vidriera verd",
  "block.minecraft.red_stained_glass_pane": "panell de vidriera roig",
  "block.minecraft.black_stained_glass_pane": "panell de vidriera negre",
  "block.minecraft.prismarine": "prismarina",
  "block.minecraft.prismarine_bricks": "rajoles de prismarina",
  "block.minecraft.dark_prismarine": "prismarina obscura",
  "block.minecraft.prismarine_stairs": "escales de prismarina",
  "block.minecraft.prismarine_brick_stairs": "escales de rajoles de prismarina",
  "block.minecraft.dark_prismarine_stairs": "escales de prismarina obscura",
  "block.minecraft.sea_lantern": "llanterna marina",
  "block.minecraft.red_sandstone": "roca arenosa roja",
  "block.minecraft.chiseled_red_sandstone": "roca arenosa roja cisellada",
  "block.minecraft.cut_red_sandstone": "roca arenosa roja tallada",
  "block.minecraft.red_sandstone_stairs": "escales de roca arenosa roja",
  "block.minecraft.repeating_command_block": "bloc de comandaments de repetició",
  "block.minecraft.chain_command_block": "bloc de comandaments encadenats",
  "block.minecraft.magma_block": "bloc de magma",
  "block.minecraft.nether_wart_block": "bloc de bolet del nether",
  "block.minecraft.warped_wart_block": "bloc de fong estrambòtic",
  "block.minecraft.red_nether_bricks": "rajoles del nether roges",
  "block.minecraft.bone_block": "bloc d'os",
  "block.minecraft.structure_void": "estructura buida",
  "block.minecraft.observer": "observador",
  "block.minecraft.shulker_box": "caixa de shulker",
  "block.minecraft.white_shulker_box": "caixa de shulker blanca",
  "block.minecraft.orange_shulker_box": "caixa de shulker taronja",
  "block.minecraft.magenta_shulker_box": "caixa de shulker magenta",
  "block.minecraft.light_blue_shulker_box": "caixa de shulker blava clara",
  "block.minecraft.yellow_shulker_box": "caixa de shulker groga",
  "block.minecraft.lime_shulker_box": "caixa de shulker verda llima",
  "block.minecraft.pink_shulker_box": "caixa de shulker rosa",
  "block.minecraft.gray_shulker_box": "caixa de shulker grisa",
  "block.minecraft.light_gray_shulker_box": "caixa de shulker grisa clara",
  "block.minecraft.cyan_shulker_box": "caixa de shulker cian",
  "block.minecraft.purple_shulker_box": "caixa de shulker morada",
  "block.minecraft.blue_shulker_box": "caixa de shulker blava",
  "block.minecraft.brown_shulker_box": "caixa de shulker marró",
  "block.minecraft.green_shulker_box": "caixa de shulker verda",
  "block.minecraft.red_shulker_box": "caixa de shulker roja",
  "block.minecraft.black_shulker_box": "caixa de shulker negra",
  "block.minecraft.white_glazed_terracotta": "terracota glacejada blanca",
  "block.minecraft.orange_glazed_terracotta": "terracota glacejada taronja",
  "block.minecraft.magenta_glazed_terracotta": "terracota glacejada magenta",
  "block.minecraft.light_blue_glazed_terracotta": "terracota glacejada blava clara",
  "block.minecraft.yellow_glazed_terracotta": "terracota glacejada groga",
  "block.minecraft.lime_glazed_terracotta": "terracota glacejada verda llima",
  "block.minecraft.pink_glazed_terracotta": "terracota glacejada rosa",
  "block.minecraft.gray_glazed_terracotta": "terracota glacejada grisa",
  "block.minecraft.light_gray_glazed_terracotta": "terracota glacejada grisa clara",
  "block.minecraft.cyan_glazed_terracotta": "terracota glacejada cian",
  "block.minecraft.purple_glazed_terracotta": "terracota glacejada morada",
  "block.minecraft.blue_glazed_terracotta": "terracota glacejada blava",
  "block.minecraft.brown_glazed_terracotta": "terracota glacejada marró",
  "block.minecraft.green_glazed_terracotta": "terracota glacejada verda",
  "block.minecraft.red_glazed_terracotta": "terracota glacejada roja",
  "block.minecraft.black_glazed_terracotta": "terracota glacejada negra",
  "block.minecraft.white_concrete": "formigó blanc",
  "block.minecraft.orange_concrete": "formigó taronja",
  "block.minecraft.magenta_concrete": "formigó magenta",
  "block.minecraft.light_blue_concrete": "formigó blau clar",
  "block.minecraft.yellow_concrete": "formigó groc",
  "block.minecraft.lime_concrete": "formigó verd llima",
  "block.minecraft.pink_concrete": "formigó rosa",
  "block.minecraft.gray_concrete": "formigó gris",
  "block.minecraft.light_gray_concrete": "formigó gris clar",
  "block.minecraft.cyan_concrete": "formigó cian",
  "block.minecraft.purple_concrete": "formigó morat",
  "block.minecraft.blue_concrete": "formigó blau",
  "block.minecraft.brown_concrete": "formigó marró",
  "block.minecraft.green_concrete": "formigó verd",
  "block.minecraft.red_concrete": "formigó roig",
  "block.minecraft.black_concrete": "formigó negre",
  "block.minecraft.white_concrete_powder": "pols de formigó blanc",
  "block.minecraft.orange_concrete_powder": "pols de formigó taronja",
  "block.minecraft.magenta_concrete_powder": "pols de formigó magenta",
  "block.minecraft.light_blue_concrete_powder": "pols de formigó blau clar",
  "block.minecraft.yellow_concrete_powder": "pols de formigó groc",
  "block.minecraft.lime_concrete_powder": "pols de formigó verd llima",
  "block.minecraft.pink_concrete_powder": "pols de formigó rosa",
  "block.minecraft.gray_concrete_powder": "pols de formigó gris",
  "block.minecraft.light_gray_concrete_powder": "pols de formigó gris clar",
  "block.minecraft.cyan_concrete_powder": "pols de formigó cian",
  "block.minecraft.purple_concrete_powder": "pols de formigó morat",
  "block.minecraft.blue_concrete_powder": "pols de formigó blau",
  "block.minecraft.brown_concrete_powder": "pols de formigó marró",
  "block.minecraft.green_concrete_powder": "pols de formigó verd",
  "block.minecraft.red_concrete_powder": "pols de formigó roig",
  "block.minecraft.black_concrete_powder": "pols de formigó negre",
  "block.minecraft.turtle_egg": "ou de tortuga marina",
  "block.minecraft.dead_tube_coral_block": "bloc de corall de tub mort",
  "block.minecraft.dead_brain_coral_block": "bloc de corall cerebral mort",
  "block.minecraft.dead_bubble_coral_block": "bloc de corall de bombolles mort",
  "block.minecraft.dead_fire_coral_block": "bloc de corall de foc mort",
  "block.minecraft.dead_horn_coral_block": "bloc de corall de banya mort",
  "block.minecraft.tube_coral_block": "bloc de corall de tub",
  "block.minecraft.brain_coral_block": "bloc de corall cerebral",
  "block.minecraft.bubble_coral_block": "bloc de corall de bombolles",
  "block.minecraft.fire_coral_block": "bloc de corall de foc",
  "block.minecraft.horn_coral_block": "bloc de corall de banya",
  "block.minecraft.tube_coral": "corall de tub",
  "block.minecraft.brain_coral": "corall cerebral",
  "block.minecraft.bubble_coral": "corall de bombolles",
  "block.minecraft.fire_coral": "corall de foc",
  "block.minecraft.horn_coral": "corall de banya",
  "block.minecraft.dead_brain_coral": "corall cerebral mort",
  "block.minecraft.dead_bubble_coral": "corall de bombolles mort",
  "block.minecraft.dead_fire_coral": "corall de foc mort",
  "block.minecraft.dead_horn_coral": "corall de banya mort",
  "block.minecraft.dead_tube_coral": "corall de tub mort",
  "block.minecraft.tube_coral_fan": "gorgònia de tub",
  "block.minecraft.brain_coral_fan": "gorgònia cerebral",
  "block.minecraft.bubble_coral_fan": "gorgònia de bombolles",
  "block.minecraft.fire_coral_fan": "gorgònia de foc",
  "block.minecraft.horn_coral_fan": "gorgònia de banya",
  "block.minecraft.dead_tube_coral_fan": "gorgònia de tub morta",
  "block.minecraft.dead_brain_coral_fan": "gorgònia cerebral morta",
  "block.minecraft.dead_bubble_coral_fan": "gorgònia de bombolles morta",
  "block.minecraft.dead_fire_coral_fan": "gorgònia de foc morta",
  "block.minecraft.dead_horn_coral_fan": "gorgònia de banya morta",
  "block.minecraft.blue_ice": "gel blau",
  "block.minecraft.conduit": "canalitzador",
  "block.minecraft.polished_granite_stairs": "escales de granit polit",
  "block.minecraft.smooth_red_sandstone_stairs": "escales de roca arenosa roja llises",
  "block.minecraft.mossy_stone_brick_stairs": "escales de rajoles de roca amb molsa",
  "block.minecraft.polished_diorite_stairs": "escales de diorita polides",
  "block.minecraft.mossy_cobblestone_stairs": "escales d'empedrat amb molsa",
  "block.minecraft.end_stone_brick_stairs": "escales de rajoles de roca de la fi",
  "block.minecraft.stone_stairs": "escales de roca",
  "block.minecraft.smooth_sandstone_stairs": "escales de roca arenosa llises",
  "block.minecraft.smooth_quartz_stairs": "escales de quars llises",
  "block.minecraft.granite_stairs": "escales de granit",
  "block.minecraft.andesite_stairs": "escales d'andesita",
  "block.minecraft.red_nether_brick_stairs": "escales de rajoles del nether roges",
  "block.minecraft.polished_andesite_stairs": "escales d'andesita polides",
  "block.minecraft.diorite_stairs": "escales de diorita",
  "block.minecraft.polished_granite_slab": "llosa de granit polida",
  "block.minecraft.smooth_red_sandstone_slab": "llosa de roca arenosa roja llisa",
  "block.minecraft.mossy_stone_brick_slab": "llosa de rajoles de roca amb molsa",
  "block.minecraft.polished_diorite_slab": "llosa de diorita polida",
  "block.minecraft.mossy_cobblestone_slab": "llosa d'empedrat amb molsa",
  "block.minecraft.end_stone_brick_slab": "llosa de rajoles de roca de la fi",
  "block.minecraft.smooth_sandstone_slab": "llosa de roca arenosa llisa",
  "block.minecraft.smooth_quartz_slab": "llosa de quars llisa",
  "block.minecraft.granite_slab": "llosa de granit",
  "block.minecraft.andesite_slab": "llosa d'andesita",
  "block.minecraft.red_nether_brick_slab": "llosa de rajoles del nether roges",
  "block.minecraft.polished_andesite_slab": "llosa d'andesita polida",
  "block.minecraft.diorite_slab": "llosa de diorita",
  "block.minecraft.scaffolding": "bastida",
  "block.minecraft.iron_door": "porta de ferro",
  "block.minecraft.oak_door": "porta de fusta de pomer",
  "block.minecraft.spruce_door": "porta de fusta d'avet",
  "block.minecraft.birch_door": "porta de fusta de bedoll",
  "block.minecraft.jungle_door": "porta de fusta d'arbre de jungla",
  "block.minecraft.acacia_door": "porta de fusta d'acàcia",
  "block.minecraft.dark_oak_door": "porta de fusta de roure",
  "block.minecraft.crimson_door": "porta de fusta carmesina",
  "block.minecraft.warped_door": "porta estrambòtica",
  "block.minecraft.repeater": "repetidor de redstone",
  "block.minecraft.comparator": "comparador de redstone",
  "block.minecraft.structure_block": "bloc d'estructura",
  "block.minecraft.jigsaw": "bloc de trencaclosques",
  "item.minecraft.turtle_helmet": "closca de tortuga marina□□al cap:□+2 armadura",
  "item.minecraft.scute": "fragments de closca de tortuga marina",
  "item.minecraft.iron_shovel": "pala de ferro□□a la mà principal:□+3.5 dany per atac□-3 velocitat d'atac",
  "item.minecraft.iron_pickaxe": "pic de ferro□□a la mà principal:□+3 dany per atac□-2.8 velocitat d'atac",
  "item.minecraft.iron_axe": "destral de ferro□□a la mà principal:□+8 dany per atac□-3.1 velocitat d'atac",
  "item.minecraft.flint_and_steel": "sílex i ferro",
  "item.minecraft.apple": "poma",
  "item.minecraft.bow": "arc de fletxes",
  "item.minecraft.arrow": "fletxa",
  "item.minecraft.coal": "carbó",
  "item.minecraft.charcoal": "carbó vegetal",
  "item.minecraft.diamond": "diamant",
  "item.minecraft.iron_ingot": "lingot de ferro",
  "item.minecraft.gold_ingot": "lingot d'or",
  "item.minecraft.netherite_ingot": "lingot de netherita",
  "item.minecraft.netherite_scrap": "fragments de netherita",
  "item.minecraft.iron_sword": "espasa de ferro□□a la mà principal:□+5 dany per atac□-2.4 velocitat d'atac",
  "item.minecraft.wooden_sword": "espasa de fusta□□a la mà principal:□+3 dany per atac□-2.4 velocitat d'atac",
  "item.minecraft.wooden_shovel": "pala de fusta□□a la mà principal:□+1.5 dany per atac□-3 velocitat d'atac",
  "item.minecraft.wooden_pickaxe": "pic de fusta□□a la mà principal:□+1 dany per atac□-2.8 velocitat d'atac",
  "item.minecraft.wooden_axe": "destral de fusta□□a la mà principal:□+6 dany per atac□-3.2 velocitat d'atac",
  "item.minecraft.stone_sword": "espasa de pedra□□a la mà principal:□+4 dany per atac□-2.4 velocitat d'atac",
  "item.minecraft.stone_shovel": "pala de pedra□□a la mà principal:□+2.5 dany per atac□-3 velocitat d'atac",
  "item.minecraft.stone_pickaxe": "pic de pedra□□a la mà principal:□+2 dany per atac□-2.8 velocitat d'atac",
  "item.minecraft.stone_axe": "destral de pedra□□a la mà principal:□+8 dany per atac□-3.2 velocitat d'atac",
  "item.minecraft.diamond_sword": "espasa de diamant□□a la mà principal:□+6 dany per atac□-2.4 velocitat d'atac",
  "item.minecraft.diamond_shovel": "pala de diamant□□a la mà principal:□+4.5 dany per atac□-3 velocitat d'atac",
  "item.minecraft.diamond_pickaxe": "pic de diamant□□a la mà principal:□+4 dany per atac□-2.8 velocitat d'atac",
  "item.minecraft.diamond_axe": "destral de diamant□□a la mà principal:□+8 dany per atac□-3 velocitat d'atac",
  "item.minecraft.stick": "pal",
  "item.minecraft.bowl": "bol",
  "item.minecraft.mushroom_stew": "estofat de xampinyons",
  "item.minecraft.golden_sword": "espasa d'or□□a la mà principal:□+3 dany per atac□-2.4 velocitat d'atac",
  "item.minecraft.golden_shovel": "pala d'or□□a la mà principal:□+1.5 dany per atac□-3 velocitat d'atac",
  "item.minecraft.golden_pickaxe": "pic d'or□□a la mà principal:□+1 dany per atac□-2.8 velocitat d'atac",
  "item.minecraft.golden_axe": "destral d'or□□a la mà principal:□+6 dany per atac□-3 velocitat d'atac",
  "item.minecraft.netherite_sword": "espasa de netherita□□a la mà principal:□+7 dany per atac□-2.4 velocitat d'atac",
  "item.minecraft.netherite_shovel": "pala de netherita□□a la mà principal:□+5.5 dany per atac□-3 velocitat d'atac",
  "item.minecraft.netherite_pickaxe": "pic de netherita□□a la mà principal:□+5 dany per atac□-2.8 velocitat d'atac",
  "item.minecraft.netherite_axe": "destral de netherita□□a la mà principal:□+9 dany per atac□-3 velocitat d'atac",
  "item.minecraft.string": "fil",
  "item.minecraft.feather": "ploma",
  "item.minecraft.gunpowder": "pólvora",
  "item.minecraft.wooden_hoe": "aixada de fusta□□a la mà principal:□-3 velocitat d'atac",
  "item.minecraft.stone_hoe": "aixada de pedra□□a la mà principal:□-2 velocitat d'atac",
  "item.minecraft.iron_hoe": "aixada de ferro□□a la mà principal:□-1 velocitat d'atac",
  "item.minecraft.diamond_hoe": "aixada de diamant□□a la mà principal:",
  "item.minecraft.golden_hoe": "aixada d'or□□a la mà principal:□-3 velocitat d'atac",
  "item.minecraft.netherite_hoe": "aixada de netherita□□a la mà principal:",
  "item.minecraft.wheat_seeds": "llavors de blat",
  "item.minecraft.wheat": "blat",
  "item.minecraft.bread": "pa",
  "item.minecraft.leather_helmet": "casc de cuir□□al cap:□+1 armadura",
  "item.minecraft.leather_chestplate": "túnica de cuir□□al cos:□+3 armadura",
  "item.minecraft.leather_leggings": "pantalons de cuir□□a les cames:□+2 armadura",
  "item.minecraft.leather_boots": "botes de cuir□□als peus:□+1 armadura",
  "item.minecraft.chainmail_helmet": "casc de cota de malla□□al cap:□+2 armadura",
  "item.minecraft.chainmail_chestplate": "cuirassa de cota de malla□□al cos:□+5 armadura",
  "item.minecraft.chainmail_leggings": "pantalons de cota de malla□□a les cames:□+4 armadura",
  "item.minecraft.chainmail_boots": "botes de cota de malla□□als peus:□+1 armadura",
  "item.minecraft.iron_helmet": "casc de ferro□□al cap:□+2 armadura",
  "item.minecraft.iron_chestplate": "cuirassa de ferro□□al cos:□+6 armadura",
  "item.minecraft.iron_leggings": "malles de ferro□□a les cames:□+5 armadura",
  "item.minecraft.iron_boots": "botes de ferro□□als peus:□+2 armadura",
  "item.minecraft.diamond_helmet": "casc de diamant□□al cap:□+3 armadura□+2 duresa de l'armadura",
  "item.minecraft.diamond_chestplate": "cuirassa de diamant□□al cos:□+8 armadura□+2 duresa de l'armadura",
  "item.minecraft.diamond_leggings": "malles de diamant□□a les cames:□+6 armadura□+2 duresa de l'armadura",
  "item.minecraft.diamond_boots": "botes de diamant□□als peus:□+3 armadura□+2 duresa de l'armadura",
  "item.minecraft.golden_helmet": "casc d'or□□al cap:□+2 armadura",
  "item.minecraft.golden_chestplate": "cuirassa d'or□□al cos:□+5 armadura",
  "item.minecraft.golden_leggings": "malles d'or□□a les cames:□+3 armadura",
  "item.minecraft.golden_boots": "botes d'or□□als peus:□+1 armadura",
  "item.minecraft.netherite_helmet": "casc de netherita□□al cap:□+3 armadura□+3 duresa de l'armadura□+1 resistència a l'espenta",
  "item.minecraft.netherite_chestplate": "cuirassa de netherita□□al cos:□+8 armadura□+3 duresa de l'armadura□+1 resistència a l'espenta",
  "item.minecraft.netherite_leggings": "malles de netherita□□a les cames:□+6 armadura□+3 duresa de l'armadura□+1 resistència a l'espenta",
  "item.minecraft.netherite_boots": "botes de netherita□□als peus:□+3 armadura□+3 duresa de l'armadura□+1 resistència a l'espenta",
  "item.minecraft.flint": "sílex",
  "item.minecraft.porkchop": "carn de porc crua",
  "item.minecraft.cooked_porkchop": "carn de porc torrada",
  "item.minecraft.painting": "quadre",
  "item.minecraft.golden_apple": "poma d'or",
  "item.minecraft.enchanted_golden_apple": "poma daurada encantada",
  "block.minecraft.oak_sign": "cartell de fusta de pomer",
  "block.minecraft.spruce_sign": "cartell de fusta d'avet",
  "block.minecraft.birch_sign": "cartell de fusta de bedoll",
  "block.minecraft.jungle_sign": "cartell de fusta d'arbre de jungla",
  "block.minecraft.acacia_sign": "cartell de fusta d'acàcia",
  "block.minecraft.dark_oak_sign": "cartell de fusta de roure",
  "block.minecraft.crimson_sign": "cartell carmesí",
  "block.minecraft.warped_sign": "cartell estrambòtic",
  "item.minecraft.bucket": "poal",
  "item.minecraft.water_bucket": "poal amb aigua",
  "item.minecraft.lava_bucket": "poal amb lava",
  "item.minecraft.minecart": "vagoneta",
  "item.minecraft.saddle": "sella de muntar",
  "item.minecraft.redstone": "pols de redstone",
  "item.minecraft.snowball": "bola de neu",
  "item.minecraft.oak_boat": "barca de fusta de pomer",
  "item.minecraft.leather": "cuir",
  "item.minecraft.milk_bucket": "poal amb llet",
  "item.minecraft.pufferfish_bucket": "poal amb peix globus",
  "item.minecraft.salmon_bucket": "poal amb salmó",
  "item.minecraft.cod_bucket": "poal amb abadejo",
  "item.minecraft.tropical_fish_bucket": "poal amb peix tropical",
  "item.minecraft.brick": "rajola",
  "item.minecraft.clay_ball": "bola d'argila",
  "block.minecraft.dried_kelp_block": "bloc d'algues seques",
  "item.minecraft.paper": "paper",
  "item.minecraft.book": "llibre",
  "item.minecraft.slime_ball": "bola de llim",
  "item.minecraft.chest_minecart": "vagoneta amb cofre",
  "item.minecraft.furnace_minecart": "vagoneta amb forn",
  "item.minecraft.egg": "ou",
  "item.minecraft.compass": "brúixola",
  "item.minecraft.fishing_rod": "canya de pescar",
  "item.minecraft.clock": "rellotge",
  "item.minecraft.glowstone_dust": "pols de roca brillant",
  "item.minecraft.cod": "abadejo cru",
  "item.minecraft.salmon": "salmó cru",
  "item.minecraft.tropical_fish": "peix tropical",
  "item.minecraft.pufferfish": "peix globus",
  "item.minecraft.cooked_cod": "abadejo torrat",
  "item.minecraft.cooked_salmon": "salmó torrat",
  "item.minecraft.ink_sac": "sac de tinta",
  "item.minecraft.red_dye": "tint roig",
  "item.minecraft.green_dye": "tint verd",
  "item.minecraft.cocoa_beans": "grans de cacau",
  "item.minecraft.lapis_lazuli": "lapislàtzuli",
  "item.minecraft.purple_dye": "tint morat",
  "item.minecraft.cyan_dye": "tint cian",
  "item.minecraft.light_gray_dye": "tint gris clar",
  "item.minecraft.gray_dye": "tint gris",
  "item.minecraft.pink_dye": "tint rosa",
  "item.minecraft.lime_dye": "tint verd llima",
  "item.minecraft.yellow_dye": "tint groc",
  "item.minecraft.light_blue_dye": "tint blau clar",
  "item.minecraft.magenta_dye": "tint magenta",
  "item.minecraft.orange_dye": "tint taronja",
  "item.minecraft.bone_meal": "farina d'ossos",
  "item.minecraft.blue_dye": "tint blau",
  "item.minecraft.brown_dye": "tint marró",
  "item.minecraft.black_dye": "tint negre",
  "item.minecraft.white_dye": "tint blanc",
  "item.minecraft.bone": "os",
  "item.minecraft.sugar": "sucre",
  "block.minecraft.cake": "pastís",
  "block.minecraft.white_bed": "llit blanc",
  "block.minecraft.orange_bed": "llit taronja",
  "block.minecraft.magenta_bed": "llit magenta",
  "block.minecraft.light_blue_bed": "llit blau clar",
  "block.minecraft.yellow_bed": "llit groc",
  "block.minecraft.lime_bed": "llit verd llima",
  "block.minecraft.pink_bed": "llit rosa",
  "block.minecraft.gray_bed": "llit gris",
  "block.minecraft.light_gray_bed": "llit gris clar",
  "block.minecraft.cyan_bed": "llit cian",
  "block.minecraft.purple_bed": "llit morat",
  "block.minecraft.blue_bed": "llit blau",
  "block.minecraft.brown_bed": "llit marró",
  "block.minecraft.green_bed": "llit verd",
  "block.minecraft.red_bed": "llit roig",
  "block.minecraft.black_bed": "llit negre",
  "item.minecraft.cookie": "galeta",
  "item.minecraft.filled_map": "mapa□#0",
  "item.minecraft.shears": "tisores d'esquilar",
  "item.minecraft.melon_slice": "rodanxa de meló d'alger",
  "item.minecraft.dried_kelp": "alga seca",
  "item.minecraft.pumpkin_seeds": "llavors de carabassa",
  "item.minecraft.melon_seeds": "llavors de meló d'alger",
  "item.minecraft.beef": "bistec cru",
  "item.minecraft.cooked_beef": "bistec torrat",
  "item.minecraft.chicken": "pollastre cru",
  "item.minecraft.cooked_chicken": "pollastre torrat",
  "item.minecraft.rotten_flesh": "carn podrida",
  "item.minecraft.ender_pearl": "perla de la fi",
  "item.minecraft.blaze_rod": "vara flamejant",
  "item.minecraft.ghast_tear": "llàgrima de ghast",
  "item.minecraft.gold_nugget": "palleta d'or",
  "item.minecraft.nether_wart": "bolet del nether",
  "item.minecraft.potion": "poció no fabricable□sense efectes",
  "item.minecraft.glass_bottle": "botella de vidre",
  "item.minecraft.spider_eye": "ull d'aranya",
  "item.minecraft.fermented_spider_eye": "ull d'aranya fermentat",
  "item.minecraft.blaze_powder": "pols de foc",
  "item.minecraft.magma_cream": "bola de magma",
  "block.minecraft.brewing_stand": "altar de pocions",
  "block.minecraft.cauldron": "calderó",
  "item.minecraft.ender_eye": "ull de la fi",
  "item.minecraft.glistering_melon_slice": "rodanxa de meló d'alger daurat",
  "item.minecraft.bat_spawn_egg": "generar ratpenat",
  "item.minecraft.bee_spawn_egg": "generar abella",
  "item.minecraft.blaze_spawn_egg": "generar flama",
  "item.minecraft.cat_spawn_egg": "generar gat",
  "item.minecraft.cave_spider_spawn_egg": "generar aranya de cova",
  "item.minecraft.chicken_spawn_egg": "generar gallina",
  "item.minecraft.cod_spawn_egg": "generar abadejo",
  "item.minecraft.cow_spawn_egg": "generar vaca",
  "item.minecraft.creeper_spawn_egg": "generar creeper",
  "item.minecraft.dolphin_spawn_egg": "generar dofí",
  "item.minecraft.donkey_spawn_egg": "generar ase",
  "item.minecraft.drowned_spawn_egg": "generar ofegat",
  "item.minecraft.elder_guardian_spawn_egg": "generar gran guardià de les profunditats",
  "item.minecraft.enderman_spawn_egg": "generar enderman",
  "item.minecraft.endermite_spawn_egg": "generar tèrmit d'ender",
  "item.minecraft.evoker_spawn_egg": "generar evocador",
  "item.minecraft.fox_spawn_egg": "generar rabosa",
  "item.minecraft.ghast_spawn_egg": "generar ghast",
  "item.minecraft.guardian_spawn_egg": "generar guardià de les profunditats",
  "item.minecraft.hoglin_spawn_egg": "generar hoglin",
  "item.minecraft.horse_spawn_egg": "generar cavall",
  "item.minecraft.husk_spawn_egg": "generar mòmia",
  "item.minecraft.llama_spawn_egg": "generar llama",
  "item.minecraft.magma_cube_spawn_egg": "generar cub de magma",
  "item.minecraft.mooshroom_spawn_egg": "generar vaca amb xampinyons",
  "item.minecraft.mule_spawn_egg": "generar mula",
  "item.minecraft.ocelot_spawn_egg": "generar ocelot",
  "item.minecraft.panda_spawn_egg": "generar panda",
  "item.minecraft.parrot_spawn_egg": "generar lloro",
  "item.minecraft.phantom_spawn_egg": "generar ànima",
  "item.minecraft.pig_spawn_egg": "generar porc",
  "item.minecraft.piglin_spawn_egg": "generar piglin",
  "item.minecraft.pillager_spawn_egg": "generar bandit",
  "item.minecraft.polar_bear_spawn_egg": "generar os polar",
  "item.minecraft.pufferfish_spawn_egg": "generar peix globus",
  "item.minecraft.rabbit_spawn_egg": "generar conill",
  "item.minecraft.ravager_spawn_egg": "generar bèstia dels bandits",
  "item.minecraft.salmon_spawn_egg": "generar salmó",
  "item.minecraft.sheep_spawn_egg": "generar ovella",
  "item.minecraft.shulker_spawn_egg": "generar shulker",
  "item.minecraft.silverfish_spawn_egg": "generar peixet de plata",
  "item.minecraft.skeleton_spawn_egg": "generar esquelet",
  "item.minecraft.skeleton_horse_spawn_egg": "generar cavall esquelètic",
  "item.minecraft.slime_spawn_egg": "generar cub de llim",
  "item.minecraft.spider_spawn_egg": "generar aranya",
  "item.minecraft.squid_spawn_egg": "generar calamar",
  "item.minecraft.stray_spawn_egg": "generar esquelet glacial",
  "item.minecraft.strider_spawn_egg": "generar caminant",
  "item.minecraft.trader_llama_spawn_egg": "generar llama de càrrega",
  "item.minecraft.tropical_fish_spawn_egg": "generar peix tropical",
  "item.minecraft.turtle_spawn_egg": "generar tortuga marina",
  "item.minecraft.vex_spawn_egg": "generar esperit",
  "item.minecraft.villager_spawn_egg": "generar vilatà",
  "item.minecraft.vindicator_spawn_egg": "generar defensor",
  "item.minecraft.wandering_trader_spawn_egg": "generar comerciant",
  "item.minecraft.witch_spawn_egg": "generar bruixa",
  "item.minecraft.wither_skeleton_spawn_egg": "generar esquelet de l'infern",
  "item.minecraft.wolf_spawn_egg": "generar llop",
  "item.minecraft.zoglin_spawn_egg": "generar zoglin",
  "item.minecraft.zombie_spawn_egg": "generar zombi",
  "item.minecraft.zombie_horse_spawn_egg": "generar cavall zombi",
  "item.minecraft.zombie_villager_spawn_egg": "generar vilatà zombi",
  "item.minecraft.zombified_piglin_spawn_egg": "generar piglin zombi",
  "item.minecraft.experience_bottle": "botella màgica",
  "item.minecraft.fire_charge": "projectil de foc",
  "item.minecraft.writable_book": "llibre, tinter i ploma",
  "item.minecraft.written_book": "llibre escrit",
  "item.minecraft.emerald": "maragda",
  "item.minecraft.item_frame": "marc",
  "block.minecraft.flower_pot": "test",
  "item.minecraft.carrot": "carlota",
  "item.minecraft.potato": "creïlla",
  "item.minecraft.baked_potato": "creïlla torrada",
  "item.minecraft.poisonous_potato": "creïlla enverinada",
  "item.minecraft.map": "mapa en blanc",
  "item.minecraft.golden_carrot": "carlota d'or",
  "block.minecraft.skeleton_skull": "calavera",
  "block.minecraft.wither_skeleton_skull": "calavera infernal",
  "block.minecraft.player_head": "cap del jugador",
  "block.minecraft.zombie_head": "cap de zombi",
  "block.minecraft.creeper_head": "cap de creeper",
  "block.minecraft.dragon_head": "cap del drac",
  "item.minecraft.carrot_on_a_stick": "carlota en un pal",
  "item.minecraft.warped_fungus_on_a_stick": "fong estrambòtic en un pal",
  "item.minecraft.nether_star": "estrela del nether",
  "item.minecraft.pumpkin_pie": "coca de carabassa",
  "item.minecraft.firework_rocket": "focs artificials",
  "item.minecraft.firework_star": "estrela de focs artificials",
  "item.minecraft.enchanted_book": "llibre encantat",
  "item.minecraft.nether_brick": "rajola del nether",
  "item.minecraft.quartz": "quars",
  "item.minecraft.tnt_minecart": "vagoneta amb explosius",
  "item.minecraft.hopper_minecart": "vagoneta amb tremuja",
  "item.minecraft.prismarine_shard": "fragment de prismarina",
  "item.minecraft.prismarine_crystals": "cristalls de prismarina",
  "item.minecraft.rabbit": "carn de conill crua",
  "item.minecraft.cooked_rabbit": "carn de conill torrada",
  "item.minecraft.rabbit_stew": "estofat de conill",
  "item.minecraft.rabbit_foot": "pota de conill",
  "item.minecraft.rabbit_hide": "pell de conill",
  "item.minecraft.armor_stand": "suport per a armadures",
  "item.minecraft.iron_horse_armor": "armadura de ferro per a cavalls",
  "item.minecraft.golden_horse_armor": "armadura d'or per a cavalls",
  "item.minecraft.diamond_horse_armor": "armadura de diamant per a cavalls",
  "item.minecraft.leather_horse_armor": "armadura de cuir per als cavalls",
  "item.minecraft.lead": "llaç",
  "item.minecraft.name_tag": "etiqueta de nom",
  "item.minecraft.command_block_minecart": "vagoneta amb bloc de comandaments",
  "item.minecraft.mutton": "carn d'ovella crua",
  "item.minecraft.cooked_mutton": "carn d'ovella torrada",
  "block.minecraft.white_banner": "estandart blanc",
  "block.minecraft.orange_banner": "estandart taronja",
  "block.minecraft.magenta_banner": "estandart magenta",
  "block.minecraft.light_blue_banner": "estandart blau clar",
  "block.minecraft.yellow_banner": "estandart groc",
  "block.minecraft.lime_banner": "estandart verd llima",
  "block.minecraft.pink_banner": "estandart rosa",
  "block.minecraft.gray_banner": "estandart gris",
  "block.minecraft.light_gray_banner": "estandart gris clar",
  "block.minecraft.cyan_banner": "estandart cian",
  "block.minecraft.purple_banner": "estandart morat",
  "block.minecraft.blue_banner": "estandart blau",
  "block.minecraft.brown_banner": "estandart marró",
  "block.minecraft.green_banner": "estandart verd",
  "block.minecraft.red_banner": "estandart roig",
  "block.minecraft.black_banner": "estandart negre",
  "item.minecraft.end_crystal": "cristall de la fi",
  "item.minecraft.chorus_fruit": "fruit del coral",
  "item.minecraft.popped_chorus_fruit": "fruit del coral esclafit",
  "item.minecraft.beetroot": "remolatxa",
  "item.minecraft.beetroot_seeds": "llavors de remolatxa",
  "item.minecraft.beetroot_soup": "sopa de remolatxa",
  "item.minecraft.dragon_breath": "alé de drac",
  "item.minecraft.splash_potion": "poció explosiva no fabricable□sense efectes",
  "item.minecraft.spectral_arrow": "fletxa espectral",
  "item.minecraft.tipped_arrow": "fletxa amb efecte impossible d'elaborar□sense efectes",
  "item.minecraft.lingering_potion": "poció persistent no fabricable□sense efectes",
  "item.minecraft.shield": "escut",
  "item.minecraft.elytra": "èlitres",
  "item.minecraft.spruce_boat": "barca de fusta d'avet",
  "item.minecraft.birch_boat": "barca de fusta de bedoll",
  "item.minecraft.jungle_boat": "barca de fusta de la jungla",
  "item.minecraft.acacia_boat": "barca de fusta d'acàcia",
  "item.minecraft.dark_oak_boat": "barca de fusta de roure",
  "item.minecraft.totem_of_undying": "tòtem de la immortalitat",
  "item.minecraft.shulker_shell": "closca de shulker",
  "item.minecraft.iron_nugget": "palleta de ferro",
  "item.minecraft.knowledge_book": "enciclopèdia",
  "item.minecraft.debug_stick": "pal de depuració",
  "item.minecraft.music_disc_13": "disc de música□c418 - 13",
  "item.minecraft.music_disc_cat": "disc de música□c418 - cat",
  "item.minecraft.music_disc_blocks": "disc de música□c418 - blocks",
  "item.minecraft.music_disc_chirp": "disc de música□c418 - chirp",
  "item.minecraft.music_disc_far": "disc de música□c418 - far",
  "item.minecraft.music_disc_mall": "disc de música□c418 - mall",
  "item.minecraft.music_disc_mellohi": "disc de música□c418 - mellohi",
  "item.minecraft.music_disc_stal": "disc de música□c418 - stal",
  "item.minecraft.music_disc_strad": "disc de música□c418 - strad",
  "item.minecraft.music_disc_ward": "disc de música□c418 - ward",
  "item.minecraft.music_disc_11": "disc de música□c418 - 11",
  "item.minecraft.music_disc_wait": "disc de música□c418 - wait",
  "item.minecraft.music_disc_pigstep": "disc de música□lena raine - pigstep",
  "item.minecraft.trident": "trident□□a la mà principal:□+8 dany per atac□-2.9 velocitat d'atac",
  "item.minecraft.phantom_membrane": "membrana d'ànima",
  "item.minecraft.nautilus_shell": "closca de nautilus",
  "item.minecraft.heart_of_the_sea": "el cor de la mar",
  "item.minecraft.crossbow": "ballesta",
  "item.minecraft.suspicious_stew": "estofat sospitós",
  "block.minecraft.loom": "teler",
  "item.minecraft.flower_banner_pattern": "estandard floral□estampat de flors",
  "item.minecraft.creeper_banner_pattern": "estandard de creeper□estampat de creeper",
  "item.minecraft.skull_banner_pattern": "estandard calavera□estampat de calavera",
  "item.minecraft.mojang_banner_pattern": "estandard de mojang□cosa",
  "item.minecraft.globe_banner_pattern": "estandard planeta□planeta",
  "item.minecraft.piglin_banner_pattern": "estandard de piglin□morro",
  "block.minecraft.composter": "compostador",
  "block.minecraft.barrel": "barril",
  "block.minecraft.smoker": "fumador",
  "block.minecraft.blast_furnace": "alt forn",
  "block.minecraft.cartography_table": "taula de cartografia",
  "block.minecraft.fletching_table": "taller de fletxes",
  "block.minecraft.grindstone": "mola",
  "block.minecraft.lectern": "faristol",
  "block.minecraft.smithing_table": "ferreria",
  "block.minecraft.stonecutter": "tallapedra",
  "block.minecraft.bell": "campana",
  "block.minecraft.lantern": "fanal",
  "block.minecraft.soul_lantern": "fanal d'ànimes",
  "item.minecraft.sweet_berries": "mores",
  "block.minecraft.campfire": "foguera",
  "block.minecraft.soul_campfire": "foguera d'ànimes",
  "block.minecraft.shroomlight": "bloc d'espores lluminoses",
  "item.minecraft.honeycomb": "bresca",
  "block.minecraft.bee_nest": "rusc",
  "block.minecraft.beehive": "buc",
  "item.minecraft.honey_bottle": "botella de mel",
  "block.minecraft.honey_block": "bloc de mel",
  "block.minecraft.honeycomb_block": "bloc de bresca",
  "block.minecraft.lodestone": "imant",
  "block.minecraft.netherite_block": "bloc de netherita",
  "block.minecraft.ancient_debris": "enderrocs antics",
  "block.minecraft.target": "diana",
  "block.minecraft.crying_obsidian": "obsidiana plorosa",
  "block.minecraft.blackstone": "roca negra",
  "block.minecraft.blackstone_slab": "llosa de roca negra",
  "block.minecraft.blackstone_stairs": "escales de roca negra",
  "block.minecraft.gilded_blackstone": "roca negra daurada",
  "block.minecraft.polished_blackstone": "roca negra polida",
  "block.minecraft.polished_blackstone_slab": "llosa de roca negra polida",
  "block.minecraft.polished_blackstone_stairs": "escales de roca negra polida",
  "block.minecraft.chiseled_polished_blackstone": "roca negra polida cisellada",
  "block.minecraft.polished_blackstone_bricks": "rajoles de roca negra polida",
  "block.minecraft.polished_blackstone_brick_slab": "llosa de rajoles de roca negra polida",
  "block.minecraft.polished_blackstone_brick_stairs": "escales de rajoles de roca negra polida",
  "block.minecraft.cracked_polished_blackstone_bricks": "rajoles de roca negra polida esquerdades",
  "block.minecraft.respawn_anchor": "àncora de reaparició",
}
export const val_es = items; 
